import { saveAs } from 'file-saver';
import _ from "lodash";

export default {
    methods: {
        generateForDeal() {
            this.generate(true);
        },
        generate(forDeal = false) {
            let self = this;
            this.isLoading = true;
            this.field_errors = {};
            let url = '/api/documents/generate';
            if (forDeal) url = '/api/documents/generate/deal/' + self.form_params.deal_id;
            axios({
                method: 'POST',
                url: url,
                params: self.form_params,
                responseType: 'arraybuffer'
            })
                .then(response => {
                    self.isLoading = false;
                    saveAs(new Blob([response.data]), self.form_name + '.docx', {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});
                })
                .catch(e => {
                    self.isLoading = false;
                    if (e.response && e.response.data && e.response.status === 422) {
                        let data = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(e.response.data)));
                        if (data && data.errors) self.field_errors = data.errors;
                    }
                });
        }
    }
}
